var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tenant && _vm.user)?_c('div',{staticClass:"tables-layout"},[_c('tables-app-bar'),_c('v-main',{staticClass:"no-transition"},[_c('router-transition',[_c('router-view')],1)],1),_c('tables-footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }